import { StrictMode, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

import { createQueryClient } from './lib/query';
import { ThemeProvider } from './components/theme';
import { TooltipProvider } from './components/ui/menu';

/**
 * Everything around the router. Shared by main.tsx (the browser, with a
 * BrowserRouter inside) and entry-server.tsx (the build-time prerender, with a
 * StaticRouter inside), so a prerendered page and the page the browser hydrates
 * have the same component tree above the route — the Toaster included, since
 * it renders a DOM node and a missing one would make every hydration mismatch.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <StrictMode>
      <QueryClientProvider client={createQueryClient()}>
        <ThemeProvider>
          <TooltipProvider delayDuration={300}>
            {children}
            <Toaster
              position="bottom-right"
              toastOptions={{
                classNames: {
                  toast:
                    'rounded-xl border border-[var(--line)] bg-[var(--surface)] text-[var(--text)] shadow-lg',
                  description: 'text-[var(--text-muted)]'
                }
              }}
            />
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}
